import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

import { IAugmentedJQuery, ISCEService } from 'angular';
import { formatAsDollarsWithoutZeroCents } from 'common/source/utilities/strings';
import { CurrentUserService } from 'services/currentUser';
import { getActiveEarthquakePartnerProduct, getEarthquakeQuotePremium } from 'common/source/utilities/policyInfoHelper';

const module = angular.module('consider-earthquake-coverage-section', []);

interface ConsiderEarthquakeSectionController extends angular.IStrictController {
    title: string;
    description: string;
    icon: string;
    policyInfo: CustomerPolicyInfo;
}

module.component('considerEarthquakeCoverageSection', {
    template: template,
    bindings: {
        policyInfo: '<'
    },
    controller: function(
        this: ConsiderEarthquakeSectionController,
        $sce: ISCEService,
        currentUserService: CurrentUserService,
        $element: IAugmentedJQuery
    ) {
        this.$onInit = () => {
            this.title = 'Consider Earthquake coverage';
            this.icon = 'earthquake';

            const earthquakeQuotePremium = getEarthquakeQuotePremium(this.policyInfo);

            const isInKentucky = this.policyInfo.property_data.address.state.toLowerCase() === 'ky';
            const isInArkansas = this.policyInfo.property_data.address.state.toLowerCase() === 'ar';
            const offerEarthquakeCoverage = earthquakeQuotePremium || isInKentucky || isInArkansas;

            if (!offerEarthquakeCoverage || getActiveEarthquakePartnerProduct(this.policyInfo)) {
                $element.addClass('ng-hide');
            } else if (earthquakeQuotePremium) {
                const description = `<strong>Home insurance does not cover earthquakes.</strong> However, Hippo can
                    provide optional
                    Earthquake Coverage for approximately ${formatAsDollarsWithoutZeroCents(
                        earthquakeQuotePremium
                    )}/year.
                    <br class="desktop-only"/> For more info, we’ll send a full quote with your policy and you may
                    call us at <br class="desktop-only"/> 1-800-585-0705.`;
                this.description = $sce.trustAsHtml(description);
            } else {
                const description = `<strong>Home insurance does not cover earthquakes.</strong> However, Hippo can
                    provide optional
                    Earthquake Coverage.
                    <br class="desktop-only"/> For more info, call us at 1-469-489-2317 or click below and we’ll reach out to you.`;
                this.description = $sce.trustAsHtml(description);
            }
        };
    }
});

export { module };
